import {ChangeDetectorRef, Component, EventEmitter, Output} from '@angular/core';
import * as Logger from 'js-logger';

import {PlaylistEntry} from '@app/player/scheduler.service.base';

const logger = Logger.get('image-player');

@Component({
    selector: 'siq-image-player',
    styles: [`
        :host {
            display: block;
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
        }

        :host img {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
        }

        .hide {
            opacity: 0;
        }

        .fade {
            z-index: 10;
            transition: opacity 1s linear;
        }
    `],
    template: `
        <img [ngClass]="{hide: entryIdx != 0, fade: fadeIdx == 0}" [src]="entrySources[0]">
        <img [ngClass]="{hide: entryIdx != 1, fade: fadeIdx == 1}" [src]="entrySources[1]">
        <img [ngClass]="{hide: entryIdx != 2, fade: fadeIdx == 2}" [src]="entrySources[2]">
    `,
})
export class ImagePlayerComponent {
    @Output() readonly completed: EventEmitter<any> = new EventEmitter();
    entries: Array<PlaylistEntry> = [];
    entrySources: Array<string> = new Array(3)
        // Initialize with one transparent pixel png to avoid check in template.
        .fill('data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7');
    entryIdx = -1;
    fadeIdx = -2;

    private playTimer?: any;

    get visible(): boolean {
        return this.entryIdx >= 0;
    }

    constructor(private cda: ChangeDetectorRef) {
    }

    prepare(entry: PlaylistEntry): void {
        logger.debug('preparing image for display ' + entry.source);
        this.entries[this.getNextEntryIdx()] = entry;
        this.entrySources[this.getNextEntryIdx()] = `${entry.source}`;
    }

    async play(): Promise<void> {
        this.entryIdx = this.getNextEntryIdx();
        this.fadeIdx = this.getNextFadeIdx();
        logger.debug('playing image: ' + this.entries[this.entryIdx].source);

        this.playTimer = setTimeout(() => {
            logger.debug('finished play image');
            this.playTimer = undefined;
            this.completed.emit();
        }, (this.entries[this.entryIdx].period || 10) * 1000);

        // Ensure that image is really displayed on screen when this play-method returns.
        this.cda.detectChanges();
        await new Promise(requestAnimationFrame);
    }

    stop(): void {
        if (this.playTimer !== undefined) {
            clearTimeout(this.playTimer);
            this.playTimer = undefined;
        }
        this.entryIdx = -1;
        this.fadeIdx = -2;
    }

    private getNextEntryIdx(): number {
        return (this.entryIdx + 1) % 3;
    }

    private getNextFadeIdx(): number {
        return (this.fadeIdx + 1) % 3;
    }
}
